<template>
  <router-link :to="link">
    <slot></slot>
  </router-link>
</template>

<script>
export default {
  props: {
    pageNum: {
      type: Number,
      required: true,
    },
    highlightText: {
      type: String,
    },
  },

  computed: {
    link() {
      const {highlightText, pageNum} = this
      const options = highlightText ? {query: {highlightText}} : {}
      return this.linkToPage(pageNum, options)
    },
  },

  inject: ['linkToPage'],
}
</script>
